/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Marketing_Emphasis_BodyInputs */

const en_wb_marketing_emphasis_body = /** @type {(inputs: Wb_Marketing_Emphasis_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The campaign landing page brought in more visitors, but a smaller share completed the enquiry form.`)
};

const lv_wb_marketing_emphasis_body = /** @type {(inputs: Wb_Marketing_Emphasis_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampaņas galvenā lapa piesaistīja vairāk apmeklētāju, taču mazāka daļa aizpildīja pieteikuma formu.`)
};

/**
* | output |
* | --- |
* | "The campaign landing page brought in more visitors, but a smaller share completed the enquiry form." |
*
* @param {Wb_Marketing_Emphasis_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_marketing_emphasis_body = /** @type {((inputs?: Wb_Marketing_Emphasis_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Marketing_Emphasis_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_marketing_emphasis_body(inputs)
	return en_wb_marketing_emphasis_body(inputs)
});